module.exports = __webpack_public_path__ + "static/img/fourthFX.d1d2fab2.png";